import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import OrderedDataTable from './OrderedDataTableCopy.jsx';
import OverrideRow from './OverrideRow';
import OverrideInput from './OverrideInput';
import WorkflowCommentLog from './WorkflowCommentLogCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import isNumeric from '../functions/isNumeric';
import decimalToPercent from '../functions/decimalToPercent'; 
import percentToDeciaml from '../functions/percentToDecimal'; 
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent';
import EllipsisInfoLabel from './EllipsisInfoLabel.jsx';
import PageDropdownWithIdObj from './PageDropdownWithIdObjCopy.jsx'; 
import isNullOrUndefined from '../functions/isNullOrUndefined'; 

const OverrideModal = () =>{
    // global state
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);

    // context from parent
    const {
        editRow,  
        setEditRow, 
        overrideModal, 
        setOverrideModal,
        aggregateTableHeader, 
        overrideTypeList,
        overrideType, 
        setOverrideType, 
        subCompany, 
        fullRefresh,  
        snackbarAlert,
        rebateInputTypeId, 
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);

    // state for table
    const [overrideData, setOverrideData] = useState([]);
    const [overrideHeader, setOverrideHeader] = useState([]);
    // state for override type
    const [overrideRate, setOverrideRate] = useState(0);
    const [overrideSignAmt, setOverrideSignAmt] = useState(0.0);
    const [overrideComment, setOverrideComment] = useState('');

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return(
            <>
                <OverrideRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>
            </>
        );
    } 

    // event handler for submit button click 
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            let response; 
            // apply transformation if necessary because of rebateInputTypeId if override type is rate
            let ovrRate = overrideRate; 
            if (overrideType['id'] === '0' && rebateInputTypeId == 1){ // id of 1 as percent
                ovrRate = percentToDeciaml(ovrRate); 
            }
            // validate rate and amount are numeric 
            if (overrideType['id'] === '0' && !isNumeric(ovrRate)){
                snackbarAlert(true, 'Error: Invalid override rate.', 'error');
                reject(); 
                return;
            }
            if (overrideType['id'] === '1' && !isNumeric(overrideSignAmt.replaceAll(",", ""))){
                snackbarAlert(true, 'Error: Invalid override amount.', 'error');
                reject(); 
                return;
            }
            // validate comment input
            if (overrideComment.length==0){
                snackbarAlert(true, 'Error: Please add override comment.', 'error');
                reject(); 
                return; 
            }
            // use PUT function to make request 
            PUT('/workflow/override', {
                mastercompanyid: companyInfo['mastercompanyid'], 
                rebateid: editRow['rebateid'], 
                overridetypedescription: overrideType['label'], 
                overriderate: ovrRate, 
                overrideamt: overrideSignAmt.replaceAll(",", ""), 
                workflowid: companyInfo['workflowid'], 
                commenttext: overrideComment, 
            }).then(res => {
                console.log(res);
                response = res; 
                // hide modal 
                setOverrideModal(overrideModal => overrideModal = false);
                // show snackbar on success
                snackbarAlert(true, 'Override successfully uploaded.', 'success');
                // make comment default
                setOverrideComment(overrideComment => overrideComment = '');
                // refresh data
                return fullRefresh(); 
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show snackbar on error
                snackbarAlert(true, 'Error uploading override.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // event handler for value change in commment textarea
    const onTextAreaChange = (e) =>{
        // set state to value passed in event object
        setOverrideComment(overrideComment => overrideComment = e.target.value);
    }

    // useEffect to run on change of overrideModal state variable. Toggles visibility of modal
    useEffect(() => {
        // set state for table
        setOverrideData(overrideData => overrideData = [editRow]);
        setOverrideHeader(overrideHeader => overrideHeader = [...aggregateTableHeader.slice(0, aggregateTableHeader.length-1)]);
        // set state for override type dropdown
        if (!isNullOrUndefined(editRow)){
            console.log('OVERRIDE_ROW:', editRow); 
            // if there is an override, find correct override type for dropdown
            let temp = overrideTypeList[0]; 
            for (let i = 0; i < overrideTypeList.length; i++) {
                console.log(editRow['overridetypeid'], ' === ', overrideTypeList[i]['id']); 
                if (editRow['overridetypeid'] === overrideTypeList[i]['id']) {
                    temp = overrideTypeList[i]; 
                    break; 
                }
            }
            setOverrideType(overrideType => overrideType = temp); 
        }
        else {
            setOverrideType(overrideType => overrideType = overrideTypeList[0]);
        }
        // set state for rate 
        if (!isNumeric(editRow['incentiverate']) ){
            setOverrideRate(overrideRate => overrideRate = 0);
        }
        else{
            // set override rate for input (initialized to existing rate)
            // apply transformation if necessary because of rebateInputTypeId
            if (rebateInputTypeId == 1){ // id of 1 as percent
                setOverrideRate(overrideRate => overrideRate = decimalToPercent(editRow['incentiverate'])); 
            }
            else { // default id of 0 as decimal 
                setOverrideRate(overrideRate => overrideRate = parseFloat(editRow['incentiverate']));
            }
        }
        setOverrideSignAmt(overrideSignAmt => overrideSignAmt = editRow['cycleincentiveamount'])
    }, [overrideModal]);

    // object to pass variables to PageContext
    const settings = {
        overrideRate, 
        setOverrideRate,
        overrideSignAmt,
        setOverrideSignAmt,
        overrideComment, 
        setOverrideComment,  
        overrideType,
        rebateInputTypeId, 
    };

    return(
        <> 
            <PageContext.Provider value={ settings }>
                <CCOffcanvas
                    show={overrideModal} // controls visibility of modal 
                    title='Rebate Override'
                    onCanvasClose={()=>setOverrideModal(overrideModal => overrideModal = false)}
                    bodyCssClassName="offcanvas-body"
                    offCanvasClassName="offcanvas-parent-card"
                    >
                        <div className="d-flex flex-column h-100">
                            {/* PageReadOnlyInputs to show information on the rebate workflow being overridden */}
                            <div className="bg-white p-3" style={{ fontSize: "14px" }}>
                                <div className="d-flex gap-3 flex-wrap">
                                    <EllipsisInfoLabel title={'Company:'} content={company} maxChar='50'/>
                                    <div className="vr"></div>
                                    <EllipsisInfoLabel title={'Sub Company:'} content={subCompany} maxChar='20'/>
                                    <div className="vr"></div>
                                    <EllipsisInfoLabel maxChar='50' title={'Payout Cycle:'} content={companyInfo['cyclestart'] + ' to ' + companyInfo['cycleend'] + ' [' + companyInfo['incentivefreq'] + ']'}/>
                                </div>
                            </div>
                            <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                                <div className="p-3 trail-section">
                                    <div className="bg-white trail-card">
                                        <div className='d-flex flex-column p-3'>
                                            <div className='d-flex gap-2 align-items-center justify-content-start mb-2'>
                                                {/* dropdown to choose override type */}
                                                <PageDropdownWithIdObj tag='Override Type' obj={overrideType} setObj={setOverrideType} list={overrideTypeList} width={'12em'} /> 
                                                {/* component for inputting override based on override type */}
                                                <OverrideInput />
                                            </div>
                                            <hr style={{margin:0,color:"#CCDBE3",height:"1px"}}/>
                                            {/* DataTable to show rebate information for fee Category being overridden */}
                                            <div className='mt-2'>
                                                <OrderedDataTable RowComponent={RowComponent} tableHeader={overrideHeader} dataList={overrideData} showSpinner={false} stickyFirstColumnEnabled={true} disableMaxTableHeight={true} sortingEnabled={true}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* comment log to show all comments attached*/}
                                <div className="p-3 pt-1 comment-section">
                                    <div className="bg-white comment-card" >
                                        <WorkflowCommentLog workflowid={companyInfo['workflowid']} disableHeight={true}/>
                                        {/* textarea input for new comment */}
                                        <div className="p-3" style={{borderTop: "1px solid #ECECEC"}}>
                                            <input className="w-100 input-text-field" value={overrideComment} onChange={(e)=>onTextAreaChange(e)} placeholder='Type override comments here'></input>
                                        </div>   
                                    </div>      
                                </div>      
                            </div>         
                            <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                            >
                                {/* buttons to submit and cancel override  */}
                                <ButtonComponent tag={"Cancel"} 
                                    border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                    onButtonClick={()=>setOverrideModal(overrideModal => overrideModal = false)}
                                />
                                <ApiRequestButton onButtonClick={onSubmitClick} />
                            </div>
                        </div>
                </CCOffcanvas>
            </PageContext.Provider>
        </>
    );
}

export default OverrideModal;